import React from 'react';
import CardComponent from './Card-component';
import { useTranslation } from 'react-i18next';

const ContattiComponentsMob = () => {
    const { t } = useTranslation();
    return (
        <CardComponent title={[t('contatti.address'), '1', 'ilparcocasavacanze@gmail.com']} />
    )
}

export default ContattiComponentsMob;